import * as types from '../constants/ActionTypes';
import {combineReducers} from "redux";
import {invoiceReducer} from "./InvoiceReducer";
import defaultReducer from "./CnbsReducer";
import {appReducer} from "./AppReducer";
import {userOptionsReducer} from "./UserOptionsReducer";
import {userReducer} from "./UserReducer";
import {paymentReducer} from "./PaymentReducer";

// import {clearCache} from "../components/invoice/Selectors";

const _rootReducer = combineReducers({
  app: appReducer,
  default: defaultReducer,
  invoice: invoiceReducer,
  user_options: userOptionsReducer,
  user: userReducer,
  payment: paymentReducer,
});

export const rootReducer = (state, action) => {
  if (action.type === types.LOGOUT) {
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('refreshToken');
    state = {
      user: {
        loginChecked: true,
        lastUrl: state.user.lastUrl,
        loginCount: state.user.loginCount++,
      },
      app: state.app,
    };
  }

  return _rootReducer(state, action)
};